export class ModelosRequest {
    CD_MARCA: number
    NM_ANO: number
    constructor(marca: number, anio: number) {
        this.CD_MARCA = marca
        this.NM_ANO = anio
    }
}